import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { refreshSession } from './services';
import { getEndpointUrl } from '../utils/endpoints';
import { StorageAccessToken } from '../utils/constants';

const handleLogout = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem("persist:root")
  window.location.href = '/login';
};

const createApiClient = (baseURL: string): AxiosInstance => {
  const client = axios.create({
    baseURL,
  });

  client.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      const internalConfig = config as InternalAxiosRequestConfig;
      const accessToken = localStorage.getItem(StorageAccessToken);
      if (accessToken) {
        internalConfig.headers['Authorization'] = accessToken as string
      }
      return internalConfig;
    },
    (error) => Promise.reject(error)
  );

  client.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error) => {
      const originalRequest = error.config;
      if (error.response && error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;

        refreshSession().then((e) => {
          localStorage.setItem("accessToken", e)
          originalRequest.headers.Authorization = e
          return axios(originalRequest);
        }).catch((k) => {
          // store.dispatch(openMultipleDeviceErrorModal())
          handleLogout();
        })
      }
      return Promise.reject(error);
    }
  );

  return client;
};

export const authClient = () => createApiClient(getEndpointUrl('AUTH_URL'));
export const userClient = () => createApiClient(getEndpointUrl('USER_URL'));
export const appointmentClient = () => createApiClient(getEndpointUrl('APPOINTMENT_URL'));
export const notificationClient = () => createApiClient(getEndpointUrl('NOTIFICATION_URL'));
export const paymentClient = () => createApiClient(getEndpointUrl('PAYMENT_URL'));
export const contentClient = () => createApiClient(getEndpointUrl('CONTENT_URL'));